module.exports = __webpack_public_path__ + "asset/font-Inter-VariableFont_slnt,wght-0930073eae9c4dbe.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/style/fonts/Inter/Inter-VariableFont_slnt,wght.ttf
// module id = lDZn
// module chunks = 3